// extracted by mini-css-extract-plugin
module.exports = {"md":"AuthSettingsSlot_md_1iu0P","ios":"AuthSettingsSlot_ios_2jvzO"};